"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var modal_1 = __importDefault(require("../../../../../plugins/modal"));
var utils_1 = require("../../../utils");
var payment_1 = __importDefault(require("./payment"));
var useEffect = react_1.default.useEffect;
exports.default = (function (props) {
    useEffect(function () {
        (0, utils_1.hideThirdPartyButtons)();
    }, []);
    return (react_1.default.createElement(modal_1.default, { isOpen: true, disableClose: true, className: 'paymentGateModal', overlayClassNames: 'paymentGateOverlay' },
        react_1.default.createElement("div", { className: 'paymentGate' },
            react_1.default.createElement(payment_1.default, { customerData: props.customer }))));
});
